import { KITCHEN_ISLAND } from "./2-kitchen-island";

export const SCENES = [
  KITCHEN_ISLAND
];
